<section class="referral-faq">
  <h2 class="referral-faq__title semi-bold">Frequently asked questions</h2>

  <div class="referral-faq__list">
    @for (item of visibleFaqItems; track item.question; let i = $index) {
      <div class="referral-faq-item" [class.referral-faq-item--expanded]="isExpanded(i)">
        <button
          type="button"
          class="referral-faq-question"
          (click)="toggle(i)"
          [attr.data-id]="'referral-faq-question-' + i"
          [attr.aria-expanded]="isExpanded(i)"
        >
          <span class="referral-faq-question__text semi-bold">{{ item.question }}</span>
          <span class="referral-faq-question__toggle" aria-hidden="true">
            <ds-icon icon="chevronDown" />
          </span>
        </button>

        @if (isExpanded(i)) {
          <p class="referral-faq-answer" [attr.data-id]="'referral-faq-answer-' + i">
            {{ item.answer }}
          </p>
        }
      </div>
    }
  </div>

  @if (canShowMore) {
    <div class="d-flex justify-content-center mt-6">
      <ds-button
        variant="secondary"
        label="Show more"
        (click)="showMore()"
        data-id="referral-faq-show-more"
      />
    </div>
  }

  <div id="referral-terms" class="referral-faq__terms">
    <h2 class="referral-faq__terms-title semi-bold">{{ termsTitle }}</h2>

    <div class="referral-faq__terms-scroll" data-id="referral-terms">
      <p class="referral-faq__terms-updated">{{ termsUpdated }}</p>

      @for (section of termsSections; track section.title) {
        <h3 class="referral-faq__terms-heading semi-bold">{{ section.title }}</h3>
        <p class="referral-faq__terms-body">{{ section.body }}</p>
      }
    </div>
  </div>
</section>
